/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementYandexRewardedOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementYandexRewardedOptions(value) {
    return true;
}
export function FxIdDomainSettingsAdvertisementYandexRewardedOptionsFromJSON(json) {
    return FxIdDomainSettingsAdvertisementYandexRewardedOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementYandexRewardedOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'MobileBlockId': json['MobileBlockId'] == null ? undefined : json['MobileBlockId'],
        'DesktopBlockId': json['DesktopBlockId'] == null ? undefined : json['DesktopBlockId'],
    };
}
export function FxIdDomainSettingsAdvertisementYandexRewardedOptionsToJSON(json) {
    return FxIdDomainSettingsAdvertisementYandexRewardedOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementYandexRewardedOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'MobileBlockId': value['MobileBlockId'],
        'DesktopBlockId': value['DesktopBlockId'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementYandexRewardedOptions.js.map